import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { auctionsApi, type AuctionListParams } from '../api/auctions-api';
import { activeAuctionOf } from '../schemas/auction-rules';

import { auctionKeys } from './auction-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function auctionListQueryOptions(storeId: string, params: AuctionListParams) {
  return queryOptions({
    queryKey: auctionKeys.list(storeId, params),
    queryFn: () => auctionsApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useAuctions(storeId: string, params: AuctionListParams) {
  return useQuery(auctionListQueryOptions(storeId, params));
}

/** The scheduled or live auction a store product is the lot of, or null. */
export function useActiveAuctionFor(storeId: string, storeProductId: string, enabled = true) {
  return useQuery({
    queryKey: auctionKeys.forProduct(storeId, storeProductId),
    queryFn: () => auctionsApi.list(storeId, { storeProductId, limit: 20 }),
    select: (page) => activeAuctionOf(page.items),
    enabled,
  });
}
